import React from 'react'

export default function WalletSolana() {
  return (
    <div>WalletSolana</div>
  )
}
